// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/button/dist/mdc.button.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdc-button {
    --mdc-theme-primary: #1976d2;
    --mdc-theme-secondary: #000000;
    font-family: 'Nunito Sans', Sans-serif, sans-serif;
}

.mdc-button--outlined:not(:disabled) {
    border-color: var(--mdc-theme-primary);
}
`, "",{"version":3,"sources":["webpack://./src/shared/css/material-button.css"],"names":[],"mappings":"AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":["@import \"../../../node_modules/@material/button/dist/mdc.button.min.css\";\n\n.mdc-button {\n    --mdc-theme-primary: #1976d2;\n    --mdc-theme-secondary: #000000;\n    font-family: 'Nunito Sans', Sans-serif, sans-serif;\n}\n\n.mdc-button--outlined:not(:disabled) {\n    border-color: var(--mdc-theme-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
